import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL
const baseEndpoint = '/product'

export const get = async (queryParam) => {
  const { limit, page, sorts, search, filters } = queryParam || {}

  const params = {
    limit,
    page,
    sorts: sorts?.length > 0 ? sorts : undefined,
    search: search || undefined,
    filters: filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: baseEndpoint,
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: baseEndpoint,
    data,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })

  return response?.data
}

export const deleteSingle = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}

export const bulkDelete = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `${baseEndpoint}/delete`,
    data,
  })

  return response?.data
}
